import { render, staticRenderFns } from "./lawyerSecurityFile.vue?vue&type=template&id=8e9fccc0&scoped=true"
import script from "./lawyerSecurityFile.vue?vue&type=script&lang=js"
export * from "./lawyerSecurityFile.vue?vue&type=script&lang=js"
import style0 from "./lawyerSecurityFile.vue?vue&type=style&index=0&id=8e9fccc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9fccc0",
  null
  
)

export default component.exports